/**
 * Content Creation service page
 * Changed blue buttons to orange for brand consistency
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Video, Image, FileText, Mic } from 'lucide-react'

export default function ContentCreationPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-orange-900 via-orange-800 to-red-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Content Creation</h1>
              <p className="text-xl text-orange-100 leading-relaxed mb-8">
                Creative content across all formats - video, graphics, copy, and multimedia 
                that captures attention and drives engagement across all platforms.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Create Amazing Content</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/a42fb40e-4ae6-47b6-9275-4455053113ce.jpg" 
                alt="Content Creation"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Content Types We Create</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From video production to graphic design, we create content that resonates with your audience
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6">
              <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Video className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Video Content</h3>
              <p className="text-gray-600">Video production for all social media platforms</p>
            </div>

            <div className="text-center p-6">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Image className="h-8 w-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Visual Design</h3>
              <p className="text-gray-600">Graphics, infographics, and visual storytelling</p>
            </div>

            <div className="text-center p-6">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FileText className="h-8 w-8 text-green-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Copywriting</h3>
              <p className="text-gray-600">Compelling written content and messaging</p>
            </div>

            <div className="text-center p-6">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mic className="h-8 w-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Audio Content</h3>
              <p className="text-gray-600">Podcasts, voiceovers, and audio branding</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-orange-900 to-red-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Create Compelling Content?</h2>
          <p className="text-xl text-orange-100 mb-8">
            Let our creative team bring your brand stories to life across all formats and platforms
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Start Creating</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
